
import BigButton from '@/Components/BigButton/BigButton'
import ProjectCreator from '@/Components/ProjectCreator/ProjectCreator'
import { usePlan } from '@/Hooks/UsePlan'
import useTranslation from '@/Hooks/UseTranslation'
import InterfaceActions from '@/Redux/Actions/InterfaceActions'
import ProjectsActions from '@/Redux/Actions/ProjectsActions'
import TeamsActions from '@/Redux/Actions/TeamsActions'
import ProjectsService from '@/Services/ProjectsService'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'

interface Props {
  showCreateModal: boolean
  setShowCreateModal: any
}

const MyProjects = ({ showCreateModal, setShowCreateModal }: Props) => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const {
    plan,
    tooManyActiveProjects,
    showTooManyArchivedProjectsModal,
    showTooManyProjectsModal,
    tooManyOthersProjects,
  } = usePlan()

  const { mine: myProjects } = useSelector((state: any) => state.ProjectsReducer.data)

  const isDisabled = (project: any) => {

    if (project.deleting) return true

    if (project.isMine)
      return tooManyActiveProjects

    return tooManyOthersProjects
  }

  const createProject = async (project: any) => {

    dispatch(InterfaceActions.showLoader())

    await dispatch(ProjectsActions.createAction(project))

    dispatch(InterfaceActions.hideLoader())
    setShowCreateModal(false)

    dispatch(ProjectsActions.getResultAction())
  }

  const handleArchive = async (project_id: string) => {

    if (!plan.can('archive', 'Project')) {

      showTooManyArchivedProjectsModal(t('HOME:TooManyArchivedProjects-title'))
    } else {

      try {
        await ProjectsService.archiveProject(project_id);

        await dispatch(ProjectsActions.getResultAction())

      } catch (error) {
        console.error('Error archivando proyecto:', error)
      }
    }
  };

  const elegirAsistente = async (asistentesFromUsersArray: any[]) => {
    const asistentes = asistentesFromUsersArray.map(user => {
      const nombre = `${user.name} ${user.surname} - ${user.profile}`;
      return {
        nombre: nombre,
        id: user.id,
      };
    });


    const { value: asistenteSeleccionadoId } = await Swal.fire({
      onOpen: () => {
        // Remove focus from the currently active element
        if (document.activeElement instanceof HTMLElement) {
          document.activeElement.blur();
        }
      },
      title: t('HOME:ChooseAssistant-title'),
      input: 'select',
      icon: 'warning',
      inputOptions: Object.fromEntries(asistentes.map(asistente => [asistente.id, asistente.nombre])),
      inputPlaceholder: t('HOME:ChooseAssistant-placeholder'),
      showCancelButton: true,
      preConfirm: (value) => {
        if (!value) {
          return Promise.reject(t('HOME:ChooseAssistant-must-choose'));
        }
        return Promise.resolve(value);
      },
      customClass: {
        input: 'my-custom-input-class',
      },
    });

    return asistenteSeleccionadoId;
  };

  const handleAbandonMyProject = async (project_id: string) => {
    const confirmResult = await Swal.fire({
      title: t('HOME:AbandonMyProject-title'),
      text: t('HOME:AbandonMyProject-content'),
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: t('HOME:AbandonMyProject-cancel'),
      confirmButtonText: t('HOME:AbandonMyProject-accept'),
      width: '500px',
    });

    // it needs to use useTeams hook
    // if (confirmResult.isConfirmed) {
    //   // const teamMembers: any = await dispatch(TeamsActions.getResultAction(project_id));

    //   if (teamMembers.data == 0 || teamMembers.data[0].users.length === 1 && teamMembers.data[0].users[0].profile_tag === 'pl4nner') {

    //     dispatch(ProjectsActions.deleteAction(project_id));
    //     return; // Salir de la función si no hay teamMembers
    //   }



    //   const usersArray = teamMembers.data.flatMap((teamMember: any) => {

    //     const assistantUsers = teamMember.users.filter((user: any) => user.isAssistant === true);

    //     if (assistantUsers.length > 0) {
    //       return assistantUsers.map((user: any) => ({

    //         name: user.name,
    //         surname: user.surname,
    //         profile: 'Asistente Pl4nner',
    //         id: user._id
    //       }));
    //     }
    //     else {
    //       return teamMember.users.filter((user: any) => user.profile_tag !== 'pl4nner').map((user: any) => ({
    //         name: user.name,
    //         surname: user.surname,
    //         profile: user.profile,
    //         id: user._id

    //       }));
    //     }
    //   });

    //   const asistenteSeleccionadoId = await elegirAsistente(usersArray);

    //   if (asistenteSeleccionadoId) {
    //     dispatch(ProjectsActions.delegateAction(project_id, asistenteSeleccionadoId));
    //     dispatch(ProjectsActions.abandonAction(project_id));
    //   }
    // }
  };

  const handleDelete = async (project_id: string) => {

    const result = await Swal.fire({
      title: t('HOME:DeleteProject-title'),
      text: t('HOME:DeleteProject-content'),
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: t('HOME:DeleteProject-cancel'),
      confirmButtonText: t('HOME:DeleteProject-accept'),
      width: '500px',
    })

    if (result.isConfirmed) {

      await dispatch(ProjectsActions.deleteAction(project_id))
    }
  }

  return (
    <>
      <Row className='mb-4'>
        {myProjects.map((project: any, i: number) => (
          <Col key={i} xl={2} lg={3} md={4} className="mb-2">
            <BigButton
              icon='icon-mis_proyectos'
              text={project.shortName}
              to={`/project/${project._id}`}
              altMenu={[
                {
                  icon: <img width="28" height="28" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABb0lEQVR4nO3ZXUoDMRAH8EWhqNRT6Cm8xzxlsLCSeSiUZB98sIKpQo9RT6N4B/UcgrCwskh1KVt2a5JJV2Ygj8nOLx//hzbLpKSkOouITgjNAyn7TmhLQlv1Hc11nHMHWaLmX3ZpehuA0K7YEVTv/B+bbwFU7Aj6vjYhAbwI2vHO9wTwIcij+Q5ApZV5jI6ICSAORGwAxUZwACgmggtAsRCcAIqB8AUAwOHvWuaz57xVMIQvgC5nZ+u1NJolO4I8AVqZO+8mkgLQfGicXQwWQGuEMosrLM6bb2IwAJ+RCQDlBKq9vEIazQ2AG/muD+BGpOycHTCF6TgLVHl+fcr/iJWdhzoBrcytpNC2khTCgacQtKRMcy4MIYU2U2Zzbr7PKdSaMo25ICnUUZJCKCnkV5JCkD6FyoQPuUz+B4fP0GhfQ5zAfTKACvCbUgHFMSn7zL/75mkycUfegB8EWkfKvEV+E2X9jXrngzUvJfXP6wsr118dzShiEAAAAABJRU5ErkJggg=="></img>,
                  label: t('HOME:ProjectButtonArchive'),
                  onClick: () => handleArchive(project._id)

                },
                {
                  icon: <i className="fas fa-fw fa-user-plus"></i>,
                  label: t('HOME:ProjectButtonAbandon'),
                  onClick: () => handleAbandonMyProject(project._id)

                },
                {
                  icon: <i className="fas fa-fw fa-trash-alt"></i>,
                  label: t('HOME:ProjectButtonDelete'),
                  color: '#f44336',
                  onClick: () => handleDelete(project._id)
                },
              ]}
              onDisabledClick={() => {

                if (project.isMine && tooManyActiveProjects)
                  showTooManyProjectsModal(t('HOME:TooManyActiveProjects-title'))
              }}
              disabled={isDisabled(project)}
            />
          </Col>
        ))}
      </Row>

      <ProjectCreator
        show={showCreateModal}
        onHide={() => setShowCreateModal(false)}
        onSave={(project: any) => createProject(project)}
      />
    </>
  )
}

export default MyProjects
